import React from "react";
import { Flex, AspectRatio } from "@chakra-ui/react";
import NextImage from "next/legacy/image";
import { type ResourceSimple } from "lib/sanity";
import { ResourceCard } from "components/resource-card";
import { trackWhitepaperDownloaded } from "components/event-tracking";
import { blogBlurDataUrl } from "../../constants/blur-data-urls";

const defaultImage = "https://hightouch.com/assets/meta.png";

export function ResourceLibraryCard({
  slug,
  title,
  subtitle,
  type,
  imageUrl,
  generateLandingPage,
  resourceFileUrl,
  resourceFileName,
}: ResourceSimple) {
  const fileDownloadUrl = `${resourceFileUrl}?dl=${resourceFileName}.pdf`;

  const downloadClicked = (resourceTitle: string) => {
    trackWhitepaperDownloaded(resourceTitle, {}, type.name);
  };

  return (
    <Flex as="li">
      <ResourceCard
        href={generateLandingPage ? `/resources/${slug}` : fileDownloadUrl}
        linkAriaLabel={`Read ${title}.`}
        eyebrow={type.name}
        title={title}
        excerpt={subtitle}
        image={
          <AspectRatio display={{ base: "none", md: "block" }} ratio={2 / 1} width="100%">
            <NextImage
              src={imageUrl ? imageUrl + "?w=500" : defaultImage}
              alt={title + "."}
              layout="fill"
              objectFit="cover"
              placeholder="blur"
              blurDataURL={blogBlurDataUrl}
            />
          </AspectRatio>
        }
        onClick={() => {
          if (!generateLandingPage) {
            downloadClicked(title);
          }
        }}
      />
    </Flex>
  );
}
